/**
 * Lineweight constants shared by layers/utils.ts (layer lineweight) and
 * entities/properties.ts (entity lineweight) — lineweight isn't a
 * layer-specific concept, so it doesn't belong under drawing/layers.
 *
 * Values are in hundredths of mm (30 = 0.30mm), matching what
 * OdDbLayerTableRecord.setLineWeight / OdDbEntity.setLineWeight expect.
 */
export const STANDARD_LINEWEIGHTS = [
  0, 5, 9, 13, 15, 18, 20, 25, 30, 35, 40, 50, 53, 60, 70, 80, 90, 100, 106,
  120, 140, 158, 200, 211,
] as const;

export type StandardLineweight = (typeof STANDARD_LINEWEIGHTS)[number];

// AutoCAD LineWeight.kLnWtByLayer : une entité peut hériter du lineweight de son calque
// plutôt que d'avoir une épaisseur fixe. C'est une valeur numérique ODA à part entière
// (pas une indirection nécessitant une résolution, contrairement au linetype) : elle
// transite déjà telle quelle vers OdDbEntity.setLineWeight sans changement moteur.
// N'a de sens que pour une entité (NoteConfig.props) — un calque n'a pas de "calque
// parent" dont hériter, donc absent de STANDARD_LINEWEIGHTS (utilisé par Layer).
export const BY_LAYER_LINEWEIGHT = -1;

export const ENTITY_LINEWEIGHTS = [
  BY_LAYER_LINEWEIGHT,
  ...STANDARD_LINEWEIGHTS,
] as const;

// AutoCAD LineWeight.kLnWtByLwDefault : épaisseur "Par défaut" qu'AutoCAD assigne
// nativement à tout calque neuf — hérite de la variable système LWDEFAULT du dessin,
// plutôt qu'une valeur mm figée. Distincte de BY_LAYER_LINEWEIGHT (qui n'a de sens que
// pour une entité héritant de son calque) : un calque ne peut pas hériter de lui-même.
export const LAYER_DEFAULT_LINEWEIGHT = -3;

export const LAYER_LINEWEIGHTS = [
  LAYER_DEFAULT_LINEWEIGHT,
  ...STANDARD_LINEWEIGHTS,
] as const;
